import { createContext, useContext } from 'react';

type DrawerContextType = {
  shouldDisableScrollInSnapPoint?: boolean;
  hasSnapPoints?: boolean;
};

/**
 * Drawer Context
 *
 * This context determines if content scrolling should
 * be disabled at specific snap points
 */
export const DrawerContext = createContext<DrawerContextType>({
  shouldDisableScrollInSnapPoint: false,
  hasSnapPoints: false,
});

export const useDrawerContext = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawerContext must be used within a DrawerContext.Provider');
  }
  return context;
};
